module.exports = require("lodash.isfunction");


//////////////////
// WEBPACK FOOTER
// external "lodash.isfunction"
// module id = 2
// module chunks = 0